import { render } from "./Curtain.vue?vue&type=template&id=356ddb08"
import script from "./Curtain.vue?vue&type=script&lang=js"
export * from "./Curtain.vue?vue&type=script&lang=js"
script.render = render

export default script